module.exports = __webpack_public_path__ + "img/gps_fixed-24px.610d0c6d.svg";